import { render } from "./FeaturedSection.vue?vue&type=template&id=5d5f1ff4&scoped=true"
import script from "./FeaturedSection.vue?vue&type=script&lang=js"
export * from "./FeaturedSection.vue?vue&type=script&lang=js"

import "./FeaturedSection.vue?vue&type=style&index=0&id=5d5f1ff4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d5f1ff4"]])

export default __exports__